import React, { useCallback } from 'react';
import { Button } from 'design-system/Button';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconFatPlus } from 'design-system/icons';
import SavingsProgress from 'design-system/SavingsProgress';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import { selectIsScrambled } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
const AccountGoalsSection = ({ accountId }) => {
    const { isUnlocked, onPressUpgrade } = useShouldShowUpgrade({
        benefitId: 'savingGoals',
    });
    const goal = useAppSelector((store) => store.accounts.goals[accountId]);
    const scrambled = useAppSelector(selectIsScrambled);
    const navigation = useMainStackNavigation();
    const onPress = useCallback(() => navigation.navigateDeprecated('SavingGoalEdit', {
        accountId,
        goalId: goal?.id,
    }), [accountId, goal?.id]);
    if (!isUnlocked) {
        return (<Button hug small square brandLight title="Upgrade to see goal" onPress={onPressUpgrade}/>);
    }
    return (<TouchableBounceCard withPadding={!!goal} noMarginTop noMarginBottom onDark onPress={onPress}>
      {goal ? (<SavingsProgress currency={goal.currency} balance={goal.currentBalance} goalAmount={goal.targetAmount} percentage={goal.percentageProgress} endDate={goal.targetDate} scrambled={scrambled}/>) : (<SettingsItem disabled title="Set a goal" icon={<IconFatPlus colorKey="brand"/>}/>)}
    </TouchableBounceCard>);
};
export default AccountGoalsSection;
